export default __webpack_public_path__ + "static/max-bitmoji-ba2b0b2670048884cd11b7f5ea88bf7b.png";